// src/services/ClientService.js

import API from './api';

// Client API Service
const ClientService = {
  // Get current client profile
  getCurrentProfile: async () => {
    try {
      const res = await API.get('/api/clients/me');
      return res.data;
    } catch (error) {
      console.error('Error getting profile:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Create client profile
  createProfile: async (profileData) => {
    try {
      const res = await API.post('/api/clients', profileData);
      return res.data;
    } catch (error) {
      console.error('Error creating profile:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Update client profile
  updateProfile: async (profileData) => {
    try {
      const res = await API.put('/api/clients/me', profileData);
      return res.data;
    } catch (error) {
      console.error('Error updating profile:', error.response?.data || error.message);
      throw error;
    }
  },

    // Update client profile by ID (for admin)
    updateProfileById: async (clientId, profileData) => {
        try {
          const res = await API.put(`/api/clients/${clientId}`, profileData);
          return res.data;
        } catch (error) {
          console.error('Error updating profile:', error.response?.data || error.message);
          throw error;
        }
      },
  
  // Get client by ID (for admin)
  getClientById: async (clientId) => {
    try {
      const res = await API.get(`/api/clients/user/${clientId}`);
      return res.data;
    } catch (error) {
      console.error('Error getting client:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Get all clients (for admin)
  getAllClients: async () => {
    try {
      const res = await API.get('/api/clients');
      return res.data;
    } catch (error) {
      console.error('Error getting all clients:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Add project to client (for admin)
  addProject: async (clientId, projectId) => {
    try {
      const res = await API.put(`/api/clients/${clientId}/projects`, { projectId });
      return res.data;
    } catch (error) {
      console.error('Error adding project:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Remove project from client (for admin)
  removeProject: async (clientId, projectId) => {
    try {
      const res = await API.delete(`/api/clients/${clientId}/projects/${projectId}`);
      return res.data;
    } catch (error) {
      console.error('Error removing project:', error.response?.data || error.message);
      throw error;
    }
  },
  
  // Delete client (for admin)
  deleteClient: async (clientId) => {
    try {
      const res = await API.delete(`/api/clients/${clientId}`);
      return res.data;
    } catch (error) {
      console.error('Error deleting client:', error.response?.data || error.message);
      throw error;
    }
  }
};

export default ClientService;